import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types'
import { SuccessStats } from '@src/components/sco/SuccessLP/SuccessStats'
import React from 'react'

export const successLandingHeroConfig: HeroConfig = {
  title: "We've helped over 1,000,000 startups launch.",
  description: "This is their story.  Let's make it yours.",
  backgroundColor: 'colorPalette.bg',
  backgroundGradient: 'linear(to-t, blackAlpha.500 25%, transparent 75%)',
  customContent: React.createElement(SuccessStats),
}
